import Storage from "../services/Storage";

const initialState = {
  selectedVehicle: null,
  selectedVIN: null,
  vinValidty: null,
  vehicleNotSupported: null,
};

export function modifyCustomerVehicle(state = initialState, action) {
  switch (action.type) {
    case 'SET_SELECTED_VEHICLE':
      Storage.setItem('selectedVehicle', action.selectedVehicle);
      return {
        ...state,
        selectedVehicle: action.selectedVehicle,
        selectedVIN: null,
      };
    case 'SET_SELECTED_VIN':
      Storage.setItem('selectedVIN', action.selectedVIN);
      return {
        ...state,
        selectedVehicle: null,
        selectedVIN: action.selectedVIN,
      };
    case 'CHANGE_CAR_MODAL':
      return {
        ...state,
        changeCarModal: action.changeCarModal,
        validatedVin: null,
      };
    case 'FETCH.CUSTOMER_VEHICLE_CHECK_VIN.SUCCESS':
      return {
        ...state,
        validatedVin: action.validatedVin,
      };
    case 'VEHICLE_NOT_SUPPORTED':
      return {
        ...state,
        vehicleNotSupported: true,
      };
    default:
      return state
  }
}

